import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { resetRegistration } from '../store/slices/registrationSlice';
import usePageSeo from '../hooks/usePageSeo';
import RegistrationWizard from '../components/auth/RegistrationWizard';
import AuthLayout from '../components/auth/AuthLayout';
import './AuthPages.css';

function SignupPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  usePageSeo({
    title: "הרשמה חינם למערכת ניהול קליניקות",
    description: "הירשמו חינם ל-CliniKit – מערכת ניהול קליניקות למטפלים. 30 ימי ניסיון חינם, ללא כרטיס אשראי. יומן חכם, סיכומי AI, תזכורות ועוד.",
    path: "/signup",
  });

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    dispatch(resetRegistration());
  }, [dispatch]);

  const footerLink = (
    <p>
      יש לכם כבר חשבון?{' '}
      <Link to="/login">התחברות</Link>
    </p>
  );

  return (
    <AuthLayout variant="signup" footer={footerLink}>
      <RegistrationWizard />
    </AuthLayout>
  );
}

export default SignupPage;
